import { css } from '@emotion/css';
import { RootState, useAppSelector } from 'cache/store';
import alertMsg from 'components/alert-message/alert-message';
import { lotteryHeaderMenu } from 'constants/common';
import { msgAuth } from 'constants/messageAlert';
import { colors } from 'constants/theme';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const dayWeekList = [
    { value: 1, label: 'THỨ 2' },
    { value: 2, label: 'THỨ 3' },
    { value: 3, label: 'THỨ 4' },
    { value: 4, label: 'THỨ 5' },
    { value: 5, label: 'THỨ 6' },
    { value: 6, label: 'THỨ 7' },
    { value: 0, label: 'CHỦ NHẬT' },
];

interface Props {
    onCloseMenu: (menuIndex: number, isHover: boolean) => void;
    menuIndex: number;
}

function HeaderMenuLottery(props: Props) {
    const { onCloseMenu, menuIndex } = props;
    const navigate = useNavigate();
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const [currentDayMn, setCurrentDayMn] = useState(new Date().getDay());
    const [currentDayMt, setCurrentDayMt] = useState(new Date().getDay());

    const openGame = (ltId: number) => {
        if (!isLogged) {
            alertMsg(msgAuth.login);
            return;
        }
        if (!ltId) {
            toast.error('Game đang bảo trì');
            return;
        }

        onCloseMenu(menuIndex, false);
        navigate(`/lottery?ltId=${ltId}`);
    };

    return (
        <>
            <div className={styles.header} />
            <div className={styles.viewAll}>
                <div className={styles.backgroundGame} />
                <div className={styles.container}>
                    {lotteryHeaderMenu.map((group, index) => (
                        <div className={styles.wrapLottery} key={index}>
                            <div className={styles.itemTitle}>
                                <h6 className={styles.title}>{group.title}</h6>
                                <div className={styles.heading}>
                                    {group.isFilterDate && (
                                        <>
                                            {group.type === 'MN' && (
                                                <select value={currentDayMn} onChange={(e) => setCurrentDayMn(Number(e.target.value))}>
                                                    {dayWeekList.map((day) => (
                                                        <option value={day.value} key={day.value}>
                                                            {day.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            {group.type === 'MT' && (
                                                <select value={currentDayMt} onChange={(e) => setCurrentDayMt(Number(e.target.value))}>
                                                    {dayWeekList.map((day) => (
                                                        <option value={day.value} key={day.value}>
                                                            {day.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className={styles.content}>
                                {group.type === 'MN' && <LotteryGroup onSelectGame={openGame} listGame={group.child} currentDay={currentDayMn} />}
                                {group.type === 'MT' && <LotteryGroup onSelectGame={openGame} listGame={group.child} currentDay={currentDayMt} />}
                                {group.type !== 'MN' && group.type !== 'MT' && (
                                    <ul className={styles.listGame}>
                                        {group.child.map((item, itemIndex) => (
                                            <div className={styles.gameItem} key={`${item.ltid}-${item.label}-${itemIndex}`} onClick={() => openGame(item.ltid)}>
                                                <img alt="" src={require('assets/images/icons/icon-xstt.png')} className={styles.icon} /> {item.label}
                                            </div>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

interface LotteryGroupProps {
    listGame: {
        label: string;
        ltid: number;
        openDay?: number;
    }[];
    currentDay: number;
    onSelectGame: (ltId: number) => void;
}

function LotteryGroup(props: LotteryGroupProps) {
    const { listGame, currentDay, onSelectGame } = props;
    return (
        <ul className={styles.listGame}>
            {listGame.map(
                (item, itemIndex) =>
                    currentDay === item.openDay && (
                        <div className={styles.gameItem} key={`${item.ltid}-${item.label}-${itemIndex}`} onClick={() => onSelectGame(item.ltid)}>
                            <img alt="" src={require('assets/images/icons/icon-xstt.png')} className={styles.icon} /> {item.label}
                        </div>
                    )
            )}
        </ul>
    );
}

const styles = {
    container: css`
        display: flex;
        justify-content: center;
        gap: 32px;
        padding: 14px 24px 20px;
    `,
    icon: css`
        width: 12px;
        height: 12px;
    `,
    content: css`
        margin-top: 12px;
    `,
    viewAll: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
    backgroundGame: css`
        display: none;
    `,

    viewHeader: css`
        display: flex;
        gap: 20px;
    `,
    wrapLottery: css`
        color: ${colors.white};
        min-width: 142px;
    `,
    header: css`
        display: none;
    `,
    itemTitle: css`
        display: flex;
        align-items: center;
        flex-direction: row;
        min-height: 32px;
        justify-content: flex-start;
        gap: 5px;
    `,
    heading: css`
        display: flex;
        align-items: center;
        gap: 5px;
        min-height: 28px;
        select {
            border-radius: 4px;
            background: rgba(255, 255, 255, .08);
            font-size: 12px;
            padding: 3px 5px;
            color: #ffd98a;
            border: 1px solid rgba(255, 217, 138, .55);
            font-family: var(--font-lato), sans-serif;
        }
    `,
    title: css`
        text-transform: uppercase;
        color: #ffd98a;
        font-family: var(--font-lato), sans-serif;
        text-align: left;
        font-size: 13px;
        font-weight: bold;
    `,
    listGame: css`
        list-style: none;
    `,
    gameItem: css`
        margin-bottom: 8px;
        color: rgba(255, 255, 255, .86);
        padding-left: 0px;
        font-size: 12px;
        font-weight: 300;
        &:last-child {
            margin-bottom: 0;
        }
        cursor: pointer;
        font-family: var(--font-lato), sans-serif;
        transition: color 160ms ease, transform 160ms ease;
        &:hover {
            color: ${colors.secondary};
            transform: translateX(3px);

            img {
                filter: brightness(0) invert(1) contrast(0.9);
            }
        }
    `,
};

export default HeaderMenuLottery;
